module.exports = __webpack_public_path__ + "img/012.ee5fc440.jpg";